import * as React from "react";
import { Redirect, Switch } from "react-router-dom";
import Login from "../components/login/Login";
import QuarantineManager from "../components/mail/QuarantineManager";
import AuthenticatedRoute from "./AuthenticatedRoute";
import AuthenticationRoute from "./AuthenticationRoute";

interface IRoutesProps {
  readonly isAuthenticated: boolean;
}

export default function Routes(props: IRoutesProps) {
  return (
    <Switch>
      <AuthenticationRoute
        exact={true}
        path={'/'}
        component={Login}
        redirectPath={'/mail'}
        isAuthenticated={props.isAuthenticated}
      />

      <AuthenticatedRoute
        exact={true}
        authenticatePath={'/'}
        path={'/mail'}
        component={QuarantineManager}
        isAuthenticated={props.isAuthenticated}
      />

      <Redirect to='/' />
    </Switch>
  );
}



// WEBPACK FOOTER //
// ./src/routes/Routes.tsx